/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ApiConfig} from '../../api';
import {ASSET_ERROR} from '../resources-constants';
import {AdnHttpProgressCallback, AdnHttpService} from '../../../util/adn-http.service';
import {
  createAdnHttpResource,
  createAdnHttpResourceSender,
  createAdnHttpUploadSender,
  createAdnUploadFormData
} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the FieldMapping HTTP resource (factory product). */
export class FieldMappingResource {
}

export function createFieldMappingResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const sendUpload = createAdnHttpUploadSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const FieldMapping: any = createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'fieldmappings',
    () => localUserProfile,
    'FieldMapping'
  );
  FieldMapping.create = function(defaults: any): any {
    return new FieldMapping(_.merge({}, defaults));
  };
  FieldMapping.upload = function(data: any, uploadType: any, onProgress?: AdnHttpProgressCallback): Promise<any> {
    if (!data || !(data.file || data.content)) {
      return Promise.reject(ASSET_ERROR.NO_FILE);
    }
    return sendUpload({
      method: 'POST',
      url: ApiConfig.obtain().getVersionedUri([uploadType || 'fieldmappings']),
      body: createAdnUploadFormData(data)
    }, onProgress);
  };
  return FieldMapping;
}

export const fieldMappingResourceProvider = {
  provide: FieldMappingResource,
  useFactory: createFieldMappingResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};
